export enum Lang {
    EN = "en",
    DE = "de",
}

export interface ProjectInterface {
    key: string;
    label: string;
    versionEndpoint: string;
    isProtected: boolean;
    defaultLang: Lang;
    isRealtime?: boolean;
}

export interface ChatInterface {
    id: string;
    label: string;
    messages: ChatMessage[];
    createdAt: number;
}

export type ChatMessage = { type: "user" | "assistant" | "system"; text: string };

export interface ChatItemInterface {
    id: string;
    label: string;
    messagesCount: number;
}

export interface BotChatMessage {
    role: "user" | "assistant";
    content: string;
}

export interface VoiceBotOptions {
    lang: Lang;
    voice: string;
    style: string;
    speed: number; // 0.1 to 2.0
    ttsInstructions: string;
    isRealtime: boolean;
    instructions: string;
    greeting: string;
    defaultInstruction: string;
    temperature: number; // 0 to 1

    vadThreshold: number; // e.g., 0.7
    vadMinNonSpeech: number; // in ms
    vadMinUtterance: number; // in ms
    vadMaxUtterance: number; // in ms
}

export interface ChatBotContextType {
    options: VoiceBotOptions;
    setOptions: (options: Partial<VoiceBotOptions>) => void;
}

export interface PromptBlockInterface {
    id: string;
    title: string;
    content: string;
    label: string;
}

export interface PromptVersionInterface {
    id: string;
    label: string;
    content: string;
}

export interface PromptStateInterface {
    blocks: PromptBlockInterface[];
    savedBlocks: PromptBlockInterface[];
    status: "idle" | "loading" | "failed";
    versions: PromptVersionInterface[];
    activeVersionId: string | null;
}
